import { useMemo, useState } from "react";
import { useLoadedData } from "../../toolympus/hooks/useLoadedData"
import { useSpace } from "../Spaces/SpaceContext"
import { Contact } from "./types";


export const useBirthdaysSoonContacts = () => {
  const [doLoad, setDoLoad] = useState<boolean>(false);
  const { spaceId } = useSpace();
  const data = useLoadedData<Contact[]>(`/api/s/${spaceId}/crm/contact/birthdays/upcoming`, [], !!spaceId && !!doLoad);


  const sortedContacts = useMemo(() => {
    if (!data.data?.length) return [];

    return [...data.data].sort((a, b) => {
      // Helper to get { month, day } from "YYYY-MM-DD" string
      const getMonthDay = (dateStr?: string) => {
        if (!dateStr) return { month: 99, day: 99 }; // Push contacts without birthday to the end
        const date = new Date(dateStr);
        return {
          month: date.getMonth(), // 0-indexed (0 = Jan)
          day: date.getDate()
        };
      };

      const dateA = getMonthDay(a.birth_date);
      const dateB = getMonthDay(b.birth_date);

      // Compare Months first
      if (dateA.month !== dateB.month) {
        return dateA.month - dateB.month;
      }

      // If Months are same, compare Days
      return dateA.day - dateB.day;
    });
  }, [data.data]);

  return {
    ...data,
    data: sortedContacts,
    ensureLoaded: () => setDoLoad(true),
  }
}
